import React, { useReducer, useContext, createContext, Dispatch } from "react";
import { TypeBestOf } from "../model/TypeBestOf";

const initialState = {
  allBestOf: [],
  isLoading: 0,
  startDate: new Date(),
  pickedBestOf: null,
  isNewBestOf: false,
  daysBestOf: null,
  typeBestOf: TypeBestOf.DAYS
};

type InitialStateType = {
  allBestOf: Array<any>,
  isLoading: number,
  startDate: any,
  pickedBestOf: any,
  isNewBestOf: boolean,
  daysBestOf: any,
  typeBestOf: TypeBestOf
}

const MenuBestOfContext = createContext<{
  state: InitialStateType;
  dispatch: Dispatch<any>;
}>({
  state: initialState,
  dispatch: () => null
});

export function useMenuBestOf() {
  return useContext(MenuBestOfContext);
}


const reducer = (state: InitialStateType, action: any) => {
  switch (action.type) {
    case "SET_ALL_BEST_OF":
      return {
        ...state,
        allBestOf: action.payload.allBestOf
      };
    case "UPDATE_LOADING": 
      return {
        ...state,
        isLoading: action.payload.isLoading
      };
    case "UPDATE_START_DATE":
      return {
        ...state,
        startDate: action.payload.startDate
      }
    case "SET_PICKED_BEST_OF":
      return {
        ...state,
        pickedBestOf: action.payload.pickedBestOf
      }
    case "SET_IS_NEW_BEST_OF":
      return {
        ...state,
        isNewBestOf: action.payload.isNewBestOf
      }
    case "SET_DAYS_BEST_OF":
      return {
        ...state,
        daysBestOf: action.payload.daysBestOf
      }
    case "UPDATE_TYPE_BEST_OF":
      return {
        ...state,
        typeBestOf: action.payload.typeBestOf
      }
    default:
      return state;
  }
};

export function MenuBestOfProvider({children}: any) {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <MenuBestOfContext.Provider value={{ state, dispatch }}>
      {children}
    </MenuBestOfContext.Provider>
  );
}

export default MenuBestOfProvider;
